import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import answerimg from '../../images/answer.png'
import s from '../../services/allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../../stylesheet/forcechangepassword.css'
import '../../stylesheet/changepassword.css'

import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';
// import logo from "../../images/GM-Cabs-card-logo.jpg";
import $ from 'jquery'
import GuestNav from '../navigation/guestnavbar.jsx'
import {
    withRouter
} from 'react-router-dom';
import '../../stylesheet/forcesecretquestion.css'
// import LoaderSmall from "../loader/loadersmall.jsx"

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};
const JSEncrypt = window.JSEncrypt

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        secretQues: state.secretQuesReducer.secretQues,
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchSecretQues(quesReceived) {
            dispatch(
                actions.secretQuesAction(quesReceived)
            )
        }
    })
// const JSEncrypt = window.JSEncrypt

class ForceChangesecretque extends Component {
    constructor(props) {
        super(props);
        this.state = {
            correctPassword: true,
            correctPassword1: true,
            confirmPasswordErr: true,
            newPassword: "",
            confirmPassword: "",
            value: "",
            secretAnswer: "",
            disabled: true,
            correctDob: true


        }
    }
    handleConfirmPassword = (e, value) => {
        let _this = this
        if (e.target.value === this.state.newPassword) {
            this.setState({
                [e.target.name]: e.target.value,
                confirmPasswordErr: true
            }, () => {
                if (_this.state.newPassword !== "" && _this.state.confirmPassword !== "" && _this.state.secretAnswer !== "" && _this.state.value !== "") {
                    this.setState({
                        disabled: false
                    })
                }
                else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }
        else {
            this.setState({
                confirmPasswordErr: false,
                disabled: true
            })
        }

    }
    onChange = (e, ansValue) => {
        let _this = this
        if (this.state.value === "DOB") {
            console.log("inside dob")
            var dobFormat = new RegExp(/^\s*(3[01]|[12][0-9]|0[1-9])\/(1[012]|0[1-9])\/((?:19|20)\d{2})\s*$/)
            if (dobFormat.test(ansValue)) {
                this.setState({
                    [e.target.name]: ansValue,
                    correctDob: true
                }, () => {
                    if (_this.state.newPassword !== "" && _this.state.confirmPassword !== "" && _this.state.secretAnswer !== "" && _this.state.value !== "") {
                        this.setState({
                            disabled: false,
                        })
                    }
                    else {
                        this.setState({
                            disabled: true,
                        })
                    }
                })
            }
            else {
                this.setState({
                    correctDob: false,
                    disabled: true,
                })
            }
        }
        else {
            console.log("else")
            this.setState({
                [e.target.name]: ansValue,
                correctDob: true
            }, () => {
                if (_this.state.newPassword !== "" && _this.state.confirmPassword !== "" && _this.state.secretAnswer !== "" && _this.state.value !== "") {
                    this.setState({
                        disabled: false,
                        correctDob: true
                    })
                }
                else {
                    this.setState({
                        disabled: true,
                        correctDob: true
                    })
                }
            })
        }

    }
    handleChange = (e, value) => {

        var myInput = document.getElementById("psw");
        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        var spec = document.getElementById("sp");

        // // When the user clicks on the password field, show the message box
        myInput.onfocus = function () {
            document.getElementById("errmessagebody").style.display = "block";
        }
        // When the user clicks outside of the password field, hide the message box
        myInput.onblur = function () {
            document.getElementById("errmessagebody").style.display = "none";
        }
        myInput.onkeyup = function () {
            // Validate lowercase letters
            var lowerCaseLetters = /[a-z]/g;
            if (myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // Validate capital letters
            var upperCaseLetters = /[A-Z]/g;
            if (myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if (myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // Validate length
            if (myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            //special character match
            var spe = /(?=.*[!@.+-,'#\$%\^&\*])/g;
            if (myInput.value.match(spe)) {
                spec.classList.remove("invalid");
                spec.classList.add("valid");
            } else {
                spec.classList.remove("valid");
                spec.classList.add("invalid");
            }
        }
        let _this = this
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword1: true
                }, () => {
                    if (_this.state.newPassword !== "" && _this.state.confirmPassword !== "" && _this.state.secretAnswer !== "" && _this.state.value !== "") {
                        this.setState({
                            disabled: false
                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }
                })

            }

            else {
                this.setState({
                    correctPassword1: false,
                    disabled: true
                })
            }
        }


    }
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
        this.props.fetchSecretQues(false)
    }
    handleSubmit1 = () => {
        this.props.history.push('/');
    }
    handleSelect = (event, index, value) => {
        let _this = this
        this.findDescription(value)
        this.setState({
            value
        }, () => {
            console.log(_this.state.value)
            _this.setState({
                // secAnsDisabled: false,
                correctDob: true
            })
        });
    }
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }
    changeSecretQuestion() {
        let encrypt = new JSEncrypt();
        let state = {
            accountId: localStorage.getItem('accountId'),
            applicationId: "gmcabs",
            secretPassword: this.state.secretAnswer,
            secretQuestionCode: this.state.value,
            currentPassword: this.state.newPassword
        }
        let _this = this
        let token = "Token " + localStorage.getItem('token')
        fetch(s.update_forceSecret, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': token
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    this.setState({
                        loader: false
                    })
                    setTimeout(function () {
                        _this.props.history.push('/home');
                    }, 3000);
                } else if (response.status === 400 || response.status === 401) {
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                    this.setState({
                        loader: false
                    })

                }
                else {
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    this.setState({
                        loader: false
                    })
                }
            })
    }
    validatePassword(e) {
        e.preventDefault();
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword1: true
                })

            }

            else {
                this.setState({
                    correctPassword1: false
                })
            }
        }

    }

    render() {
        const { secretQues } = this.props
        const { correctPassword1, confirmPasswordErr, correctDob } = this.state
        const height = $(window).height() - 108;
        return (
            <div className="col-md-12 forcechangepwd" style={{ minHeight: height }}>
                <GuestNav />

                <div className="row">
                    <div className="col-md-3" style={{ marginTop: "200px", marginLeft: "10px" }}>
                        <div id="errmessagebody" >
                            <span style={{ fontSize: "14px", marginLeft: "10px" }}> Password must contain following:</span><br />
                            <div style={{ marginTop: "8px", padding: "0px 15px" }}>
                                <span id="length" className="invalid">At least 8 to 15 characters </span><br />
                                <span id="capital" className="invalid">At least one upper case alphabet</span><br />
                                <span id="letter" className="invalid">At least one lower case alphabet</span><br />
                                <span id="sp" className="invalid">At least one special character ( ! @ # $ % ^ & * )</span><br />
                                <span id="number" className="invalid">At least one number</span><br />

                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />

                    <div className="col-md-7" style={{ marginTop: "150px" }}>
                        <div className="tile box-shadow-style">
                            <div className="row">
                                <div className="col-md-12" style={{ padding: "0px 30px" }}>
                                    <div className="summary-header">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <span>Change Secret Question and Password</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <SelectField
                                                value={this.state.value}

                                                onChange={this.handleSelect}
                                                name="secretQuestionCode"

                                                floatingLabelText="Secret Question"
                                                className="input-width required"
                                            >
                                                {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                    <MenuItem value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                ) : <div>Select Question</div>}
                                            </SelectField>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" style={{padding:"6px 0px 0px 40px"}} >
                                            <img style={{ bottom: "-36px", position:"relative" }} src={answerimg} alt="" />
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText={(this.state.value === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                                floatingLabelText="Secret Answer"
                                                type="text"
                                                name="secretAnswer"
                                                maxLength="50"
                                                className="input-width required"
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={correctDob ? null : "Enter correct format"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 passinput" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="New Password"
                                                type="password"
                                                id="psw"
                                                maxLength="15"
                                                name="newPassword"
                                                className="input-width required"
                                                onFocus={this.handleChange.bind(this)}
                                                onChange={this.handleChange.bind(this)}
                                                onBlur={this.validatePassword.bind(this)}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={correctPassword1 ? null : "Invalid password."}
                                            />
                                            <span className="col-sm-1" toggle="#psw" className="fa fa-fw fa-eye field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                        {/* <div className="col-sm-1 tooltip" style={{ top: "35px" }}>
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            <span className="tooltiptext" style={{ fontSize: "12px" }} >Your Password must contain at least 8 character, one number, one lowercase ,special character and one uppercase letter </span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Confirm Password"
                                                type="password"
                                                id="loginpassword"
                                                maxLength="15"
                                                name="confirmPassword"
                                                className="input-width required"
                                                style={{ zIndex: "0" }}
                                                onChange={this.handleConfirmPassword}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={confirmPasswordErr ? null : "New password and confirm password are not same."}
                                            />
                                            <span className="col-sm-1" toggle="#loginpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="offset-sm-4 col-sm-2" style={{ marginRight: "40px" }}>
                                            <RaisedButton
                                                label="Cancel"
                                                className="pull-right"
                                                // style={styles.button}
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.handleSubmit1.bind(this)}
                                                style={{ marginTop: "10px" }}
                                            />
                                        </div>
                                        <div className="col-sm-1">
                                            <RaisedButton
                                                label="Change"
                                                className="pull-right"
                                                // style={styles.button}
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.changeSecretQuestion.bind(this)}
                                                style={{ marginTop: "10px" }}
                                                disabled={this.state.disabled}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForceChangesecretque));



// WEBPACK FOOTER //
// ./src/components/forcesecretPassword/forcesecretPassword.jsx